import { Box, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const GENERAL_ERRORS = 'generalErrors';

const useGeneralErrorReset = () => {
  const {
    clearErrors,
    formState: { submitCount },
    watch,
  } = useFormContext();

  useEffect(() => {
    if (submitCount === 0) {
      return;
    }

    const watchSubscription = watch(() => {
      clearErrors(GENERAL_ERRORS);
    });

    return () => watchSubscription.unsubscribe();
  }, [submitCount]);
};

const FormErrors = () => {
  const theme = useTheme();
  const { formState } = useFormContext();
  useGeneralErrorReset();
  const { errors } = formState;

  if (!errors[GENERAL_ERRORS]) {
    return null;
  }

  return (
    <div>
      {errors[GENERAL_ERRORS].message!.toString()
        .split('\n')
        .map((error) => (
          <Box
            key={error}
            sx={{
              color: theme.palette.error.main,
              display: 'block',
            }}
          >
            {error}
          </Box>
        ))}
    </div>
  );
};

export default FormErrors;
